import React, { useCallback } from 'react';

import Button, { ButtonVariant } from '@/components/button';
import Divider from '@/components/divider';
import AcresLogo from '@/components/icons/AcresLogo';
import BaseModal from '@/components/modal/baseModal';
import ModalHeading from '@/components/modal/modalHeading';
import Typography from '@/components/typography';

type Props = {
  title: string;
  subTitle: string;
  disclaimer: string;
  ctaOneLabel?: string;
  ctaOneUrl?: string;
  ctaTwoLabel?: string;
  ctaTwoUrl?: string;
  onClose: () => void;
};

const PlatMapAnnouncementModal: React.FC<Props> = ({
  title,
  subTitle,
  disclaimer,
  ctaOneLabel = undefined,
  ctaOneUrl = undefined,
  ctaTwoLabel = undefined,
  ctaTwoUrl = undefined,
  onClose,
}) => {
  const openUrl = useCallback((url) => {
    window.open(url);
  }, []);

  return (
    <BaseModal
      Content={
        <div className="flex flex-col gap-y-5">
          <div className="flex gap-x-2">
            {ctaTwoLabel && ctaTwoUrl && (
              <Button
                className="flex w-full"
                variant={ButtonVariant.SECONDARY}
                onClick={() => openUrl(ctaTwoUrl)}
              >
                {ctaTwoLabel}
              </Button>
            )}
            {ctaOneLabel && ctaOneUrl && (
              <Button
                className="flex w-full"
                variant={ButtonVariant.PRIMARY}
                onClick={() => openUrl(ctaOneUrl)}
              >
                {ctaOneLabel}
              </Button>
            )}
          </div>
          {disclaimer && (
            <>
              <Divider />
              <Typography className="text-gray-100" variant="body3">
                {disclaimer}
              </Typography>
            </>
          )}
        </div>
      }
      Header={
        <ModalHeading
          icon={<AcresLogo className="h-10" />}
          title={title}
          onXClick={onClose}
        />
      }
      SupportText={
        <Typography className="text-gray-100" variant="body1">
          {subTitle}
        </Typography>
      }
      className="w-[400px]"
    />
  );
};

export default PlatMapAnnouncementModal;
